import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Et } from 'src/app/interfaces/et';
import { Sr } from 'src/app/interfaces/sr';
import { SrDetalle } from 'src/app/interfaces/srDetalle';
import { Vehiculo } from 'src/app/interfaces/vehiculo';
import { EtService } from 'src/app/service/et.service';
import { SrService } from 'src/app/service/sr.service';
import { VehiculoService } from 'src/app/service/vehiculo.service';
import { MatDialog } from '@angular/material/dialog';
import { RechazoComponent } from '../rechazo/rechazo.component';
import { ConformadoComponent } from '../conformado/conformado.component';


@Component({
  selector: 'app-et-envio-form',
  templateUrl: './et-envio-form.component.html',
  styleUrls: ['./et-envio-form.component.css']
})
export class EtEnvioFormComponent implements OnInit {
  public id =0;
  public sr:Sr;
  public et:Et;
  vehiculos?:Vehiculo[];
  public listSrD:SrDetalle[] ;
  constructor(private srService:SrService,private vehiculoService:VehiculoService , private etService:EtService,private dialogRef: MatDialogRef<EtEnvioFormComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog) {
    this.CargarInfo();
    this.sr={
      dni:0,
      origen_nombre:"",
      email:"",
      telefono:0,
      origen_provincia:"",
      origen_localidad:"",
      origen_direccion:"",
      origen_altura:0,
      origen_cp:"",
      origen_piso_departamento:"",
      id_franja_horaria:1,
      destino_cuit:0,
      destino_nombre:"",
      destino_telefono:0,
      destino_provincia:"",
      destino_localidad:"",
      destino_direccion:"",
      destino_entrecalles:"",
      destino_altura:0,
      destino_cp:"",
      destino_email:"",
      destino_piso_departamento:"",
      is_contrareembolso:false,
      contrareembolso_valor:0,
      contrareembolso_pago:false
    };
    this.et={
      id_sr:0,
      id_vehiculo:1,
      id_personal:1,
      id_estado:5,
      motivo:''
    };
    this.vehiculos?.push({
      id:0,
      marca:"",
      modelo:"",
      ano:0,
      patente:"",
      detalle:"",
      estado:true
    });
    this.listSrD=new Array<SrDetalle>();

console.log(data);
    this.etService.getById(data.id_et).toPromise().then((pEt:Et) =>{
      this.et=pEt;
      this.srService.getById(this.et.id_sr).subscribe((element:Sr) =>{
        this.sr=element;
        // console.log(element);
        this.srService.getDetalle(this.et.id_sr).subscribe((detalle:any)=>{
        this.listSrD=detalle;
        });
        });
    })


   }

  ngOnInit(): void {

  }
  private CargarInfo(){
    console.log('cargando el slect');
    this.vehiculoService.getVehiculos().subscribe((data:Vehiculo[]) =>{
      console.log('vehiculo traidos');
      console.log(data);
      this.vehiculos=data;
    });
    console.log(this.vehiculos);}
  tipoEnvio(estado:number){
    this.et.id_estado=estado;
  }
  enviar(){



        this.etService.postNuevaEt(this.et).then(id => {
          console.log(id);
          this.id=id;

        });


  }
  recibirEt(id_estado:number)
  {

    if(id_estado===4){
      let dialogRef = this.dialog.open(RechazoComponent, {
        data: {motivo: ''},
        maxHeight: '90vh'
      });
      dialogRef.afterClosed().subscribe(result => {
        // console.log('rechazos', result);

          // return data;
          if(result!==''){
          this.et.motivo=result;
          console.log(this.et.motivo)
          this.et.id_estado=id_estado;
          this.etService.cambioEstado(this.et).finally(() => {this.dialogRef.close(this.id);});
          // this.dialog.closeAll();
        }
      });
    }else{
      if(id_estado===7){
        let dialogRef = this.dialog.open(ConformadoComponent, {
          data: {motivo: ''},
          maxHeight: '90vh'
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('conformado:', result);

            // return data;
            if(result!==''){
            this.et.motivo=result;
            console.log(this.et.motivo)
            this.et.id_estado=id_estado;
            this.etService.cambioEstado(this.et).finally(() => {this.dialogRef.close(this.id);});
            // this.dialog.closeAll();
          }
        });
      }else{
        this.et.id_estado=id_estado;
        this.etService.cambioEstado(this.et).finally(() => {this.dialogRef.close(this.id);});
      }


    }


  }


}
